'use client';
import { cn } from '@/lib/utils';

import { Divider } from '@/components/atoms/divider';
import { useTheme } from '@/components/ThemeProvider';
import { Themes } from '@/components/themeProviderUtils';

import { Colors } from '@/styles/types';

export interface BlockWrapperProps {
  children: React.ReactNode;
  theme?: Themes;
  backgroundColor?: Colors;
  showDivider?: boolean;
  classNames?: {
    root?: string;
    inner?: string;
    dividerWrapper?: string;
    divider?: string;
  };
}

// globals.css max-section-width class
export const maxSectionWidth = '1024';

// TODO we can add data-tracker-section required as a prop not to forget and use it here
export function BlockWrapper({
  children,
  theme: outerTheme,
  backgroundColor = 'neutral-N00',
  showDivider,
  classNames,
  ...rest
}: BlockWrapperProps) {
  const { theme: globalTheme } = useTheme();
  const theme = outerTheme || globalTheme;

  const fallbackThemeTemp = theme.includes('dark') ? 'dark' : 'light';
  const fallbackGlobalTheme = globalTheme.includes('dark') ? 'dark' : 'light';

  return (
    <>
      <section
        {...rest}
        className={cn(
          'w-full px-5 py-8 md:px-10 md:py-[3.75rem] lg:py-20',
          fallbackThemeTemp,
          fallbackThemeTemp === 'dark'
            ? 'bg-neutral-dark-N99'
            : `bg-${backgroundColor}`,
          classNames?.root
        )}
      >
        <div
          className={cn('max-section-width mx-auto my-0', classNames?.inner)}
        >
          {children}
        </div>
      </section>
      {(showDivider || fallbackGlobalTheme === 'dark') && (
        <div
          className={cn(
            'mx-auto my-0 -mt-px w-full max-w-[1064px] px-5 md:max-w-[1104px] md:px-10',
            fallbackThemeTemp,
            classNames?.dividerWrapper
          )}
        >
          <Divider
            alignment='horizontal'
            showOnDark
            classNames={{
              root: cn(
                fallbackThemeTemp === 'dark' && 'border-neutral-dark-N80',
                classNames?.divider
              ),
            }}
          />
        </div>
      )}
    </>
  );
}
